<div class="loader-component" [ngClass]="{'visible': show}">
  <div class="loader-overlay" *ngIf="show">
    <div class="load-bar">
      <div class="bar"></div>
      <div class="bar"></div>
    </div>
  </div>
</div>
